export default "__VITE_ASSET__Bgdx$0xf__"